<template>
  <qx-card-form title="预支手续费设置">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="160px"
    />
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      originData: {},
      baseForm: {
        form: [
          {
            label: '可否预支',
            value: 'isAdvance',
            type: 'radio',
            default: 1,
            options: [
              {
                label: '是',
                value: 1,
              },
              {
                label: '否',
                value: 0,
              },
            ],
          },
          {
            label: '预支手续费比例',
            value: 'counterFee',
            type: 'input',
          },
          {
            label: '不可预支的提示语',
            value: 'noAdvanceHint',
            type: 'input',
          },
        ],
        rules: {
        },
      },
    };
  },
  methods: {
    async sub () {
      const result = {};
      const formData = await this.$refs.baseForm.sub();
      Object.keys(this.originData).forEach((key) => {
        if (key === 'freight') {
          this.originData[key].forEach((freightItem, freightIndex) => {
            Object.keys(freightItem).forEach((freightKey) => {
              result[`transportCostSection_${freightIndex}.${freightKey}`] = freightItem[freightKey];
            });
          });
        } else if (key !== 'premium') {
          result[`creditRatingRules_0.${key}`] = this.originData[key];
        }
      });
      Object.keys(formData).forEach((key) => {
        result[`creditRatingRules_0.${key}`] = formData[key];
      });
      return result;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      return {
        ...this.originData,
        ...res,
      };
    },
    async init (data = {}) {
      data.isAdvance = data.isAdvance ? data.isAdvance : 0;
      this.originData = data;
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
